import { render, staticRenderFns } from "./EventModule.vue?vue&type=template&id=188ba2ba&"
import script from "./EventModule.vue?vue&type=script&lang=js&"
export * from "./EventModule.vue?vue&type=script&lang=js&"
import style0 from "./EventModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports